(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-cinematic-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ccCanvasMotion) return;
  window.ccCanvasMotion = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const controllers = new Map();
  let frame = 0;
  const allowed = () => !reduced.matches && !window.Shopify?.designMode;
  const automaticVideo = () => !reduced.matches && !navigator.connection?.saveData;
  const sync = () => {
    document.body.classList.toggle('cc-motion-on', allowed());
    document.body.classList.toggle('cc-motion-paused', !allowed());
    controllers.forEach(c => c.sync());
    requestTick();
  };
  const tick = () => {
    frame = 0;
    const height = window.innerHeight;
    controllers.forEach(c => c.tick(height));
  };
  const requestTick = () => { if (!frame) frame = requestAnimationFrame(tick); };
  const initialise = root => {
    root.querySelectorAll('.cc-stage').forEach(section => {
      if (controllers.has(section)) return;
      const abort = new AbortController();
      const signal = abort.signal;
      if (section.classList.contains('cc-hero') && allowed() && section.dataset.ccMotion !== 'false') section.classList.add('cc-hero-arrived');
      const videos = new Map();
      const pending = new Set(section.querySelectorAll('[data-cc-reveal]'));
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const element = entry.target;
          if (allowed() && section.dataset.ccMotion !== 'false') {
            element.classList.add('cc-reveal-running');
            element.addEventListener('animationend', () => element.classList.remove('cc-reveal-running'), {once:true, signal});
          }
          pending.delete(element);
          observer.unobserve(element);
        }), {threshold:.09});
        pending.forEach(element => observer.observe(element));
      }
      section.querySelectorAll('[data-cc-video]').forEach(video => {
        const state = {visible:!('IntersectionObserver' in window), manualPause:false, automaticPause:false};
        videos.set(video,state);
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        const selectSource = () => {
          video.autoplay = video.dataset.autoplay === 'true' && automaticVideo() && !state.manualPause;
          const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
          const poster = mobile.matches ? video.dataset.mobilePoster || video.dataset.desktopPoster : video.dataset.desktopPoster;
          if (poster) video.poster = poster;
          if (source && video.getAttribute('src') !== source) {
            video.src = source;
            if (state.visible) video.load();
          }
        };
        selectSource();
        mobile.addEventListener('change', selectSource, {signal});
        video.addEventListener('pause', () => {
          if (!state.automaticPause && state.visible && !document.hidden) state.manualPause = true;
          state.automaticPause = false;
        }, {signal});
        video.addEventListener('play', () => { state.manualPause = false; }, {signal});
        video.addEventListener('loadeddata', () => updateVideo(video,state), {signal});
        video.addEventListener('canplay', () => updateVideo(video,state), {signal});
        if ('IntersectionObserver' in window) {
          state.observer = new IntersectionObserver(entries => {
            state.visible = entries[0].isIntersecting;
            updateVideo(video,state);
          }, {threshold:.15});
          state.observer.observe(video);
        }
      });
      const updateVideo = (video,state) => {
        if (!state.visible || document.hidden) {
          if (!video.paused) {state.automaticPause = true; video.pause();}
        } else if (video.dataset.autoplay === 'true' && automaticVideo() && !state.manualPause) {
          video.muted = true;
          video.play().catch(() => {});
        }
      };
      const carousel = section.querySelector('[data-cc-carousel]');
      if (carousel) {
        const controls = section.querySelector('[data-cc-carousel-controls]');
        if (controls) {
          controls.hidden = false;
          const previous = controls.querySelector('[data-cc-previous]');
          const next = controls.querySelector('[data-cc-next]');
          const updateButtons = () => {
            previous.disabled = carousel.scrollLeft < 2;
            next.disabled = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 2;
          };
          const move = direction => carousel.scrollBy({left:direction * ((carousel.firstElementChild?.getBoundingClientRect().width || carousel.clientWidth) + 14),behavior:allowed()?'smooth':'auto'});
          previous.addEventListener('click',()=>move(-1),{signal});
          next.addEventListener('click',()=>move(1),{signal});
          carousel.addEventListener('scroll',updateButtons,{passive:true,signal});
          window.addEventListener('resize',updateButtons,{passive:true,signal});
          updateButtons();
        }
      }
      const controller = {
        tick(height) {
          if (!section.querySelector('[data-cc-parallax]') && !section.hasAttribute('data-cc-statement')) return;
          if (!allowed() || mobile.matches || section.dataset.ccMotion === 'false') {
            section.style.setProperty('--cc-progress','0');
            return;
          }
          const rect = section.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > height) return;
          const progress = section.classList.contains('cc-hero') ? Math.max(0,Math.min(1,-rect.top / rect.height)) : Math.max(0,Math.min(1,(height-rect.top)/(height+rect.height)));
          section.style.setProperty('--cc-progress',progress.toFixed(4));
        },
        sync() {
          videos.forEach((state,video) => {
            video.autoplay = video.dataset.autoplay === 'true' && automaticVideo() && !state.manualPause;
            if (!automaticVideo() && !video.paused && video.dataset.autoplay === 'true') {state.automaticPause=true; video.pause();}
            else updateVideo(video,state);
          });
        },
        destroy() {
          abort.abort(); observer?.disconnect();
          videos.forEach((state,video)=>{state.observer?.disconnect();video.pause();});
        }
      };
      controllers.set(section,controller);
    });
    sync();
  };
  const boot = () => {
    initialise(document);
    document.addEventListener('shopify:section:load', event => initialise(event.target));
    document.addEventListener('shopify:section:unload', event => {
      controllers.forEach((controller,section) => {
        if (event.target.contains(section)) {controller.destroy();controllers.delete(section);}
      });
    });
    document.addEventListener('visibilitychange',sync);
    window.addEventListener('pageshow',sync);
    window.addEventListener('scroll',requestTick,{passive:true});
    window.addEventListener('resize',requestTick,{passive:true});
    reduced.addEventListener('change',sync);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
